import type { FaireProductEntity } from "../../entity_types/product";

export const p_qp37t4za26: FaireProductEntity = {
  token: "p_qp37t4za26",
  type: "product",
  name: "Let It Snow Holiday Sweatshirt | Unisex Xmas Crewneck",
  brandToken: "b_gaqv5mfhp3",
  brandName: "G & J Avenue",
  imageUrl:
    "https://cdn.faire.com/fastly/32d1896838cfda2830b6f9ffe83faabe51462c860c9010c97f258694fd8a4f89.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8bf8ced1502adf293ac70a19de5588508b346ecbdec493d017348c1f42141b9c.png",
    "https://cdn.faire.com/fastly/9382383cf4d5cbdaf4c84582f94f604d1ac7186a862f7a18d5ff375584a0bf0e.png",
    "https://cdn.faire.com/fastly/40c60bd6fdfe1c2a98faa019015cdb52449119efb69b7e44a9f14ff6ff01585e.png",
    "https://cdn.faire.com/fastly/eb31634e3964d09a330a181066f98ae05277302647194557be7f093c7cb2929f.png",
    "https://cdn.faire.com/fastly/f1706e4605fe75ab260b8c9278b2c33daf37b76f8a68db16a4fb2f31db63ae5b.png",
  ],
  priceDollars: 30.3,
  description:
    "Our Let It Snow sweatshirt - Keep it minimal! - a perfect holiday crewneck for him or her. Available in multiple colors and sizes-\n\n*Designed in house* \nFleece Lined\nUnisex Fit\nSlightly oversized\nCozy and super soft\n\nDesign adhered professionally with vinyl. Machine wash, do not iron over decorations. \nMade with 50% sustainably and fairly grown USA cotton",
  tags: [],
  msrpDollars: 55.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:45.236Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
